export const title = 'Insufficient amount of data to display';
export const subTitle =
    'Insufficient data to be displayed. <Link>Try changing your filter</Link> to find better results';
export const viewData =
    'Your query resulted in {{numberOfClusters}} clusters. <Link>Click here</Link> to view the results';
